import cfgDefault from './defaultConfig';
import cfgDevOps from './dev-ops';
import cfgDevOpsCn from './dev-ops-cn';
import cfgDevTF from './dev-tf';
import cfgDevTFCn from './dev-tf-cn';
import cfgDrOps from './dr-ops';
import cfgDrTF from './dr-tf';
import cfgLocalOps from './local-ops';
import cfgLocalTF from './local-tf';
import cfgProdOps from './prod-ops';
import cfgProdOpsCn from './prod-ops-cn';
import cfgProdTF from './prod-tf';
import cfgProdTFCn from './prod-tf-cn';
import cfgQAOps from './qa-ops';
import cfgQATF from './qa-tf';

export const defaultConfig = cfgDefault;
export const devOps = cfgDevOps;
export const devTF = cfgDevTF;
export const devTFCn = cfgDevTFCn;
export const devOpsCn = cfgDevOpsCn;
export const qaTF = cfgQATF;
export const qaOps = cfgQAOps;
export const drTF = cfgDrTF;
export const drOps = cfgDrOps;

export const prodTFCn = cfgProdTFCn;
export const prodOpsCn = cfgProdOpsCn;
export const prodOps = cfgProdOps;
export const prodTF = cfgProdTF;
export const localTF = cfgLocalTF;
export const localOps = cfgLocalOps;
